// src/components/SchemaMarkup.js
import React from 'react';

const SchemaMarkup = ({ date }) => {
  const formattedDate = date || new Date().toLocaleDateString();
  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Skimz",
    "alternateName": "Skimz Daily News Brief",
    "url": "https://skimz.ai",
    "description": "Modern news dashboard delivering essential stories across markets, tech, and global affairs in just 10 minutes daily. Built for brains in a hurry.",
    "potentialAction": {
      "@type": "ReadAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://skimz.ai"
      }
    }
  };

  // Add NewsArticle structured data
  const newsArticleSchema = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": "Skimz Daily Brief",
    "datePublished": new Date(formattedDate).toISOString(),
    "dateModified": new Date().toISOString(),
    "description": "Daily curated news brief covering markets, geopolitics, tech, health, and more in a format designed for busy professionals.",
    "publisher": {
      "@type": "Organization",
      "name": "Skimz",
      "url": "https://skimz.ai"
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://skimz.ai"
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(newsArticleSchema)}
      </script>
    </>
  );
};

export default SchemaMarkup;